// @ts-nocheck
import React, { Component } from 'react';

/**
 * Component that handles if you click outside of it
 */
export default class OutsideClickHandler extends Component {
  constructor(props: any) {
    super(props);

    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setWrapperRef(node: any) {
    this.wrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event: any) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.props.outsideClickHandler();
    }
  }

  render() {
    return <div className="outside-click-hoc" ref={this.setWrapperRef}>{this.props.children}</div>;
  }
}
